if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.mql = window.matchMedia('(min-width: 750px)');

        if (!this.elements.thumbnails || !this.elements.viewer) return;

        // FIX: Shopify debounce moet beschikbaar zijn — fallback alleen als hij echt ontbreekt
        const safeDebounce = typeof debounce === 'function'
          ? debounce
          : (fn) => fn;

        // FIX: slideChanged event error-safe
        this.elements.viewer.addEventListener(
          'slideChanged',
          safeDebounce(this.onSlideChanged.bind(this), 300)
        );

        // Thumbnail-clicks
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((thumb) => {
          const btn = thumb.querySelector('button');
          if (!btn) return;
          btn.addEventListener('click', () =>
            this.setActiveMedia(thumb.dataset.target, false)
          );
        });

        // Desktop layout
        if (this.dataset.desktopLayout?.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }
      }

      onSlideChanged(event) {
        const mediaId = event?.detail?.currentElement?.dataset?.mediaId;
        if (!mediaId) return;

        const thumb = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(thumb);
      }

      setActiveMedia(mediaId, prepend) {
        if (!mediaId) return;

        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');

        if (!activeMedia) return;

        // Reset alle media-items
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((el) =>
          el.classList.remove('is-active')
        );

        activeMedia.classList.add('is-active');

        // Optioneel: media naar voren halen
        if (prepend) {
          const container = activeMedia.parentElement;
          if (container.firstChild !== activeMedia) container.prepend(activeMedia);
        }

        // Scroll correct plaatsen
        window.setTimeout(() => {
          const container = activeMedia.parentElement;
          if (container) container.scrollTo({ left: activeMedia.offsetLeft, behavior: 'smooth' });
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;

        // Thumbnail bijwerken
        const thumb = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(thumb);

        this.announceLiveRegion(activeMedia, thumb?.dataset?.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!thumbnail || !this.elements.thumbnails) return;

        this.elements.thumbnails.querySelectorAll('button').forEach((btn) =>
          btn.removeAttribute('aria-current')
        );

        thumbnail.querySelector('button')?.setAttribute('aria-current', true);

        if (this.elements.thumbnails.isSlideVisible && this.elements.thumbnails.isSlideVisible(thumbnail, 10)) {
          return;
        }

        if (this.elements.thumbnails.slider) {
          this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
        }
      }

      announceLiveRegion(activeItem, position) {
        if (!this.elements.liveRegion) return;

        const img = activeItem.querySelector('.product__modal-opener--image img');
        if (!img) return;

        img.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 1500);
        };

        img.src = img.src;
      }

      playActiveMedia(activeItem) {
        if (window.pauseAllMedia) window.pauseAllMedia();

        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia && deferredMedia.loadContent) {
          deferredMedia.loadContent(false);
        }
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;

        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems?.forEach((slide) =>
          slide.setAttribute('role', 'presentation')
        );
      }
    }
  );
}
